var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLabelingBox = function SvgLabelingBox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0093EE",
    d: "M7.582 23.778l11.03 4.046a1 1 0 0 1 .656.939v7.218a1 1 0 0 1-1.376.927l-11.03-4.47a1 1 0 0 1-.625-.926v-6.795a1 1 0 0 1 1.345-.939z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.473 26.673l7.851 3.032M8.473 28.886l7.851 3.032M8.473 31.027l7.851 3.032"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3F536E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.668 22.82V37.81l-20.992 8.396V20.728l20.992-8.397v10.49zM23.343 46.205L2.35 37.81V12.33l20.994 8.397v25.477zm1.166-43.67l20.184 8.073L24.51 18.65 4.39 10.608l20.12-8.073zM49 20.844V10.61c0-.48-.29-.907-.735-1.085L24.942.197a1.171 1.171 0 0 0-.866 0L.75 9.525a1.17 1.17 0 0 0-.731 1.085v27.987c-.001.476.29.907.73 1.085l23.327 9.328a1.148 1.148 0 0 0 .866 0l23.323-9.328c.446-.18.735-.607.735-1.085V20.844z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#3F536E",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M13.916 14.986l21.676-8.831"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLabelingBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/labeling_box.7e440b12.svg";
export { ForwardRef as ReactComponent };